//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductTransferQuery: any = {
    ProduceEpimProductToSyncQueue: Backofficebff + '/v1/producttransfer/produceepimproducttosyncqueue',

    ConsumeEpimProductQueueForKafka: Backofficebff + '/v1/producttransfer/consumeepimproductqueueforkafka',
};
